<template>
    <div class="inform-container" :class="{active:!noticeVisiable}">
        <i class="el-icon-close" @click="close"></i>
        <p class="title">{{ messageTypeOpt[msgContent.messageType] }}</p>
        <p class="name">您有一条新的消息<span class="view" @click="clickView">点击查看</span>！</p>
        <!-- <div class="content" v-html="msgContent.content"></div>1 -->
    </div>
</template>

<script>
    export default {
        data(){
            return {
                messageTypeOpt:{
                    0:'系统公告',
                    1:'消息',
                    2:'账号通知'
                }
            }
        },
        methods:{
            close(){
                this.$store.commit('notice/changeNoticeVisiable',false);
            },
            /**查看消息体 */
            clickView(){
                this.$emit('view_msg');
            }
        },
        computed:{
            noticeVisiable(){
                return this.$store.state.notice.noticeVisiable;
            },
            msgContent(){
                return this.$store.state.notice.msgContent;
            }
        }
    }
</script>

<style lang="less" scoped>
.active{
    transform: translateX(30rem) !important;
}
.name{
    font-weight: 700;
    text-align: center;
    white-space: var(--lineWrap);
    margin-top: 10px;
    font-size: 14px;
}
.inform-container{
    border-radius: 1rem;
    color: #334681;
    width: 25rem;
    position: fixed;
    z-index: 999;
    top:8rem;
    max-height: 100%;
    overflow: auto;
    right: 0;
    background-color: #ffffff;
    text-align: left;
    font-size: 16px;
    padding: 1rem;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    transition: all 0.3s;
    .el-icon-close{
        position: absolute;
        right: 1rem;
        top: 1rem;
        cursor: pointer;
    }
    .title{
        font-weight: 700;
    }
    .content{
        white-space: var(--lineWrap);
        font-size: 14px;
        margin-top: 10px;
    }
}
.view{
    color: var(--blue);
    cursor: pointer;
    font-weight: 400;
}
</style>